import { useState } from 'react';
import PropTypes from 'prop-types';
import { normalizeForCompare } from '@/utils/millesimaUtils';
import CheckboxFilter from './CheckboxFilter';
import BlocFilter from './BlocFilter';

import styles from './CheckboxBlocFilterContainer.module.scss';
import Icon from '@/components/common/iconedLinks/Icon';
import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { FILTERS_TYPE } from '@/constants/categ';
import { URLS } from '@/constants/urls';

// Show search input if more items than this value
const SEARCH_THRESHOLD = 10;

const components = {
  [FILTERS_TYPE.BLOC]: BlocFilter,
  [FILTERS_TYPE.CHECKBOX]: CheckboxFilter
};

const CheckboxBlocFilterContainer = (
  { t, filter, onChange, selectedValue = {}, className, isModalFilter = false, reversed = false }
) => {
  const [filteredValues, setFilteredValues] = useState(filter);
  const SpecificFilter = components[filter.type];
  const isMobileOrTablet = useScreenSizeContext().isMobileOrTablet;

  const onChangeInput = (event) => {
    const valueFromEvent = event.target.value.trim();
    if (valueFromEvent) {
      const search = normalizeForCompare(valueFromEvent);
      const newValues = filter.nbByValue.filter(({ value }) => normalizeForCompare(value).includes(search));
      setFilteredValues({ ...filter, nbByValue: newValues });
    } else {
      setFilteredValues(filter);
    }
  };

  return (
    <>
      {(filter.type === FILTERS_TYPE.CHECKBOX) && (filter.nbByValue?.length > SEARCH_THRESHOLD) && (
        <section className={styles['input-container']}>
          {isMobileOrTablet && (
            <div className={styles['search-icon']}>
              <Icon src={URLS.PRIMEUR_SEARCH} alt="search" width={24} height={24} />
            </div>
          )}
          <input
            type="text"
            placeholder={t('btn.search')}
            onChange={onChangeInput}
            className={styles['input-text']}
          />
        </section>
      )}
      {SpecificFilter && (
        <SpecificFilter
          filter={filteredValues}
          onChange={onChange}
          selectedValue={selectedValue}
          className={className}
          isModalFilter={isModalFilter}
          reversed={reversed}
        />
      )}
    </>
  );
};

CheckboxBlocFilterContainer.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    type: PropTypes.oneOf([FILTERS_TYPE.BLOC, FILTERS_TYPE.CHECKBOX]),
    nbByValue: PropTypes.array
  }).isRequired,
  selectedValue: PropTypes.object
};

export default CheckboxBlocFilterContainer;
